// Search Console names a property either "sc-domain:example.com" or the URL prefix itself, and that
// string is the property's only identifier - there is no id beside it, and no account above it. The
// list is grouped the way Search Console's own picker is: one group per site, the domain property
// first and the URL prefixes that fall under it beneath.

const DOMAIN_PROPERTY_PREFIX = "sc-domain:";

export const isDomainProperty = siteUrl => siteUrl.startsWith(DOMAIN_PROPERTY_PREFIX);

export const hostOf = siteUrl => isDomainProperty(siteUrl)
    ? siteUrl.slice(DOMAIN_PROPERTY_PREFIX.length)
    : new URL(siteUrl).hostname;

export function siteOption(siteUrl) {
    // A URL-prefix property keeps its scheme: http and https are separate properties in Search
    // Console, so dropping it would show two rows that read the same. A domain property has no
    // scheme to begin with - it covers both.
    const displayName = isDomainProperty(siteUrl) ? hostOf(siteUrl) : siteUrl;

    return { label: displayName, value: siteUrl, displayName };
}

export function groupSiteOptions(sites) {
    // A domain property owns every prefix on its own host and on any subdomain of it, which is what
    // that kind of property covers. A prefix with no domain property above it stands as its own site.
    const domains = sites.filter(isDomainProperty).map(hostOf);
    const siteOf = siteUrl => {
        const host = hostOf(siteUrl);
        return domains.find(domain => host === domain || host.endsWith("." + domain))
            ?? host.replace(/^www\./, "");
    };

    const grouped = new Map();
    sites.forEach(siteUrl => {
        const key = siteOf(siteUrl);
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(siteUrl);
    });

    return [...grouped.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([site, siteUrls]) => ({
            label: site,
            options: siteUrls
                .sort(domainPropertyFirstThenAlphabetical)
                .map(siteOption),
        }));
}

function domainPropertyFirstThenAlphabetical(a, b) {
    if (isDomainProperty(a) !== isDomainProperty(b)) return isDomainProperty(a) ? -1 : 1;
    return a.localeCompare(b);
}
